import axiosInstance from "./config";

export const api = axiosInstance;